<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs :breadCrumbs="breadCrumbs" :title="title" :back_title="back_title" :link="link" />
            <div class="page">
                <div class="mt-2 mb-2 text-center">
                    <router-link class="btn btn-green btn_vw" to="/request/payments/create">
                        {{ $t("request.to_create") }}
                    </router-link>
                </div>
                <template v-if="is_generalnyi">
                    <div v-if="organizations.length">
                        <div class="accordion accordion-flush mb-2" v-for="org in organizations" :key="org.id"
                            :id="'accordionFlush-' + org.id">
                            <div class="accordion-item p-3 rounded">
                                <h2 class="accordion-header" :id="'flush-heading-' + org.id">
                                    <button class="accordion-button collapsed p-0 fs-7" type="button"
                                        data-bs-toggle="collapse" :data-bs-target="'#flush-collapse-' + org.id"
                                        aria-expanded="false" :aria-controls="'flush-collapse-' + org.id"
                                        @click="toggleOrg(org.id)">
                                        <h3 class="d-flex align-items-center" style="font-size: 20px;">
                                            {{ org.name }}
                                            <small class="ms-2 text-muted" style="font-size: 14px;">({{
                                                orgState[org.id]?.pagination?.total || 0 }})</small>
                                        </h3>
                                    </button>
                                </h2>

                                <div class="accordion-collapse collapse" :id="'flush-collapse-' + org.id"
                                    :aria-labelledby="'flush-heading-' + org.id"
                                    :data-bs-parent="'#accordionFlush-' + org.id">
                                    <div class="p-2">

                                        <!-- Лоадер внутри аккордеона -->
                                        <div v-if="orgState[org.id]?.loading" class="py-3">
                                            <spinner />
                                        </div>

                                        <!-- Контент организации -->
                                        <div v-else>
                                            <div v-if="(orgState[org.id]?.items || []).length">

                                                <!-- КАРТОЧКИ ЗАЯВОК (1:1 как у тебя, только источник — orgState[org.id].items) -->
                                                <div class="item_title mb-2" v-for="list in orgState[org.id].items"
                                                    :key="list.id">
                                                    <!-- Номер и статус -->
                                                    <div class="d-flex justify-content-between fs-7 mb-2">
                                                        <div class="fs-5 fw-bold lh-base">№{{ list.id }}</div>
                                                        <div :class="list.status"
                                                            class="badge fs-7 fw-normal lh-base px-3 rounded-pill">{{
                                                                list.status_title }}</div>
                                                    </div>

                                                    <!-- Данные платёжки -->
                                                    <div class="mt-3 fw-normal">

                                                        <!-- Дата -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.created') }}:</div>
                                                            <div class="fw-bold">{{ list.date_create }}</div>
                                                        </div>

                                                        <!-- Контрагент -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.counterparty') }}:</div>
                                                            <div class="fw-bold text-end ps-4">{{ list.counteragent ? list.counteragent.name : '—'
                                                                }}</div>
                                                        </div>

                                                        <!-- Сумма -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.amount') }}:</div>
                                                            <div class="fw-bold">{{ cur(list.payment_amount) }} {{
                                                                list.currency }}</div>
                                                        </div>

                                                        <!-- Категория -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.category') }}:</div>
                                                            <div class="fw-bold text-end ps-4">{{ list.category.name }}
                                                            </div>
                                                        </div>

                                                        <!-- Тип платежа -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.payment_type') }}:</div>
                                                            <div class="fw-bold">{{ list.payment_type }}</div>
                                                        </div>

                                                        <!-- Платёжный документ -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.provide_payment_card') }}:
                                                            </div>
                                                            <div class="vstack">
                                                                <div class="hstack justify-content-end ps-2"
                                                                    v-if="Object.keys(list.payment_documents).length > 0">
                                                                    <div>
                                                                        <div v-for="file in list.payment_documents"
                                                                            :key="file.id">
                                                                            <a data-fancybox="data-fancybox"
                                                                                :href="file.link" class="attachment"
                                                                                style="cursor: pointer;"
                                                                                v-if="file.type">
                                                                                <fa class="icon opacity-50 me-2"
                                                                                    icon="paperclip"></fa>
                                                                                №{{ list.payment_number }}
                                                                            </a>
                                                                            <a :href="file.link" target="_blank"
                                                                                class="attachment"
                                                                                style="cursor: pointer;" v-else>
                                                                                <fa class="icon opacity-50 me-2"
                                                                                    icon="paperclip"></fa>
                                                                                №{{ list.payment_number }}
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="fw-bold text-end">{{
                                                                    list.payment_document }}</div>
                                                            </div>
                                                        </div>

                                                        <!-- Доверенность -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.provide_power_attorney')
                                                                }}:</div>
                                                            <div class="d-flex justify-content-between align-items-start"
                                                                v-if="Object.keys(list.attorney_document).length > 0">
                                                                <div>
                                                                    <div v-for="file in list.attorney_document"
                                                                        :key="file.id">
                                                                        <a data-fancybox="data-fancybox"
                                                                            :href="file.link" class="attachment"
                                                                            style="cursor: pointer;" v-if="file.type">
                                                                            <fa class="icon opacity-50 me-2"
                                                                                icon="paperclip"></fa> Доверенность
                                                                        </a>
                                                                        <a :href="file.link" target="_blank"
                                                                            class="attachment" style="cursor: pointer;"
                                                                            v-else>
                                                                            <fa class="icon opacity-50 me-2"
                                                                                icon="paperclip"></fa> Доверенность
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else class="fw-bold">{{ list.letter_attorney }}</div>
                                                        </div>

                                                        <!-- Заявитель -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.applicant') }}:</div>
                                                            <div class="fw-bold">
                                                                {{ list.user ? list.user.surname + ' ' + list.user.name
                                                                    : 'Пользователь удалён' }}
                                                            </div>
                                                        </div>

                                                        <!-- Статус -->
                                                        <div
                                                            class="hstack justify-content-between border-bottom pb-2 mb-2">
                                                            <div class="fs-7">{{ $t('request.status') }}:</div>
                                                            <div class="fw-bold text-end ps-4">{{ list.status_text }}
                                                                <div v-if="revisionFromTo(list)" class="text-muted fw-normal"
                                                                    style="font-size: 0.7rem;">{{ revisionFromTo(list) }}</div>
                                                            </div>
                                                        </div>

                                                        <!-- Назначение -->
                                                        <div class="vstack justify-content-between pb-3 mb-4">
                                                            <div class="pt-2 pb-1 fs-7">{{ $t('request.appointment') }}:
                                                            </div>
                                                            <div class="fw-bold w-100">{{ list.comment }}</div>
                                                        </div>

                                                        <!-- Прикреплённые файлы -->
                                                        <div class="attchmts mb-4"
                                                            v-if="(list.files.length > 0) || (Object.keys(list.user_files).length > 0)">
                                                            <h6>Прикрепленные файлы</h6>

                                                            <!-- От заявителя -->
                                                            <div v-if="list.files.length > 0">
                                                                <div class="alert alert-attachments mb-2 rounded-3"
                                                                    role="alert">
                                                                    <div class="fw-semibold ps-1 mb-2 fs-7">
                                                                        <fa class="icon me-2 opacity-50"
                                                                            icon="user-tie"></fa>
                                                                        {{ list.user ? list.user.surname + ' ' +
                                                                            list.user.name : 'Пользователь удалён' }}
                                                                    </div>
                                                                    <div v-for="file in list.files" :key="file.id">
                                                                        <a data-fancybox :href="file.link"
                                                                            class="attachment mb-1" v-if="file.type">
                                                                            <fa class="icon me-2" icon="paperclip"></fa>
                                                                            {{ file.name }}
                                                                        </a>
                                                                        <a @click="downloadURL(file.link, file.name)"
                                                                            class="attachment mb-1" v-else>
                                                                            <fa class="icon me-2" icon="paperclip"></fa>
                                                                            {{ file.name }}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- От сотрудников -->
                                                            <div v-if="Object.keys(list.user_files).length > 0">
                                                                <div v-for="(items, name) in list.user_files"
                                                                    :key="name">
                                                                    <div class="alert alert-attachments mb-2 rounded-3"
                                                                        role="alert">
                                                                        <div class="fw-semibold ps-1 mb-2 fs-7">
                                                                            <fa class="icon me-2 opacity-50"
                                                                                icon="user-tie"></fa>{{ name }}
                                                                        </div>
                                                                        <div v-for="item in items" :key="item">
                                                                            <a data-fancybox :href="item.link"
                                                                                class="attachment mb-1"
                                                                                style="cursor: pointer;"
                                                                                v-if="item.type">
                                                                                <fa class="icon me-2" icon="paperclip">
                                                                                </fa> {{ item.name }}
                                                                            </a>
                                                                            <a @click="downloadURL(file.link, file.name)"
                                                                                class="attachment mb-1"
                                                                                style="cursor: pointer;" v-else>
                                                                                <fa class="icon me-2" icon="paperclip">
                                                                                </fa> {{ item.name }}
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> <!-- /attachments -->

                                                    </div> <!-- /fw-normal -->

                                                    <!-- Кнопки действий -->
                                                    <div class="col-sm position-relative mb-2 mt-2"
                                                        v-if="!list.first_signature">
                                                        <router-link class="btn btn-yellow w-100"
                                                            :to="`/request/payments/edit/${list.id}`">
                                                            <fa class="icon me-2 opacity-50" icon="arrows-rotate"></fa>
                                                            {{ $t('request.button.revision') }}
                                                        </router-link>
                                                    </div>

                                                    <div v-if="!list.in_bh_work">
                                                        <div class="col-sm position-relative mb-2 mt-2"
                                                            v-if="list.status === 'in_work' || list.status === 'revision'">
                                                            <button class="btn btn-red w-100"
                                                                @click="confirmDelete(list.id)">
                                                                <fa class="icon me-2 opacity-50" icon="trash-can"></fa>
                                                                {{ $t('request.button.delete') }}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm position-relative mb-2 mt-2"
                                                        v-if="list.status === 'denied'">
                                                        <button class="btn w-100 btn-green" @click="showModal(list.id)">
                                                            <fa class="icon me-2 opacity-50" icon="check"></fa>
                                                            {{ $t('request.button.return_to_work') }}
                                                        </button>
                                                    </div>

                                                    <hr />

                                                    <div class="col-sm position-relative mb-2 mt-2">
                                                        <button class="btn gray w-100"
                                                            @click="getHistory(list.historys)">
                                                            <fa class="icon me-2 opacity-50" icon="file-lines"></fa>
                                                            {{ $t('request.button.history') }}
                                                        </button>
                                                    </div>
                                                </div> <!-- /card -->

                                                <!-- Локальный пагинатор конкретной организации -->
                                                <div class="pager pager--inner">
                                                    <div class="pager__info">
                                                        Показаны
                                                        {{ orgState[org.id].pagination.from || 0 }}–{{
                                                            orgState[org.id].pagination.to || 0 }}
                                                        из {{ orgState[org.id].pagination.total || 0 }}
                                                    </div>

                                                    <div class="pager__controls">
                                                        <button class="pager__btn"
                                                            :class="{ 'is-disabled': orgState[org.id].pagination.current_page <= 1 }"
                                                            :disabled="orgState[org.id].pagination.current_page <= 1"
                                                            @click="changeOrgPage(org.id, orgState[org.id].pagination.current_page - 1)"
                                                            aria-label="Предыдущая" title="Предыдущая">
                                                            <fa icon="chevron-left" />
                                                        </button>

                                                        <div class="pager__current">
                                                            Стр. <b>{{ orgState[org.id].pagination.current_page || 1
                                                            }}</b> /
                                                            {{ orgState[org.id].pagination.last_page || 1 }}
                                                        </div>

                                                        <button class="pager__btn"
                                                            :class="{ 'is-disabled': orgState[org.id].pagination.current_page >= orgState[org.id].pagination.last_page }"
                                                            :disabled="orgState[org.id].pagination.current_page >= orgState[org.id].pagination.last_page"
                                                            @click="changeOrgPage(org.id, orgState[org.id].pagination.current_page + 1)"
                                                            aria-label="Следующая" title="Следующая">
                                                            <fa icon="chevron-right" />
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div v-else class="text-muted py-2">
                                                Заявок нет.
                                            </div>
                                        </div>
                                        <!-- /Контент организации -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div class="mb-3">
                            <div class="item_title fw-semibold">
                                {{ $t('request.list_requests_is_empty') }}
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-if="lists.length">
                        <div class="item_title mb-2" v-for="list in lists" :key="list.id">
                            <!-- Номер и статус -->
                            <div class="d-flex justify-content-between fs-7 mb-2">
                                <div class="fs-5 fw-bold lh-base">№{{ list.id }}</div>
                                <div :class="list.status" class="badge fs-7 fw-normal lh-base px-3 rounded-pill">{{
                                    list.status_title }}</div>
                            </div>

                            <!-- Данные платёжки -->
                            <div class="mt-3 fw-normal">

                                <!-- Дата -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.created') }}:</div>
                                    <div class="fw-bold">{{ list.date_create }}</div>
                                </div>

                                <!-- Контрагент -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.counterparty') }}:</div>
                                    <div class="fw-bold text-end ps-4">{{ list.counteragent ? list.counteragent.name : '—' }}</div>
                                </div>

                                <!-- Сумма -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.amount') }}:</div>
                                    <div class="fw-bold">{{ cur(list.payment_amount) }} {{ list.currency }}</div>
                                </div>

                                <!-- Категория -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.category') }}:</div>
                                    <div class="fw-bold text-end ps-4">{{ list.category.name }}</div>
                                </div>

                                <!-- Тип платежа -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.payment_type') }}:</div>
                                    <div class="fw-bold">{{ list.payment_type }}</div>
                                </div>

                                <!-- Платёжный документ -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.provide_payment_card') }}:</div>
                                    <div class="vstack">
                                        <div class="hstack justify-content-end ps-2"
                                            v-if="Object.keys(list.payment_documents).length > 0">
                                            <div>
                                                <div v-for="file in list.payment_documents" :key="file.id">
                                                    <a data-fancybox="data-fancybox" :href="file.link"
                                                        class="attachment" style="cursor: pointer;" v-if="file.type">
                                                        <fa class="icon opacity-50 me-2" icon="paperclip"></fa>
                                                        №{{ list.payment_number }}
                                                    </a>
                                                    <a :href="file.link" target="_blank" class="attachment"
                                                        style="cursor: pointer;" v-else>
                                                        <fa class="icon opacity-50 me-2" icon="paperclip"></fa>
                                                        №{{ list.payment_number }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="fw-bold text-end">{{ list.payment_document }}</div>
                                    </div>

                                </div>

                                <!-- Доверенность -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.provide_power_attorney') }}:</div>
                                    <div class=" d-flex justify-content-between align-items-start"
                                        v-if="Object.keys(list.attorney_document).length > 0">
                                        <div>
                                            <div v-for="file in list.attorney_document" :key="file.id">
                                                <a data-fancybox="data-fancybox" :href="file.link" class="attachment"
                                                    style="cursor: pointer;" v-if="file.type">
                                                    <fa class="icon opacity-50 me-2" icon="paperclip"></fa> Доверенность
                                                </a>
                                                <a :href="file.link" target="_blank" class="attachment"
                                                    style="cursor: pointer;" v-else>
                                                    <fa class="icon opacity-50 me-2" icon="paperclip"></fa> Доверенность
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="fw-bold">{{ list.letter_attorney }}</div>
                                </div>


                                <!-- Заявитель -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.applicant') }}:</div>
                                    <div class="fw-bold">{{ list.user ? list.user.surname + ' ' + list.user.name :
                                        'Пользователь удалён' }}</div>
                                </div>

                                <!-- Статус -->
                                <div class="hstack justify-content-between border-bottom pb-2 mb-2">
                                    <div class="fs-7">{{ $t('request.status') }}:</div>
                                    <div class="fw-bold text-end ps-4">{{ list.status_text }}
                                        <div v-if="revisionFromTo(list)" class="text-muted fw-normal"
                                            style="font-size: 0.7rem;">{{ revisionFromTo(list) }}</div>
                                    </div>
                                </div>

                                <!-- Назначение -->
                                <div class="vstack justify-content-between pb-3 mb-4">
                                    <div class="pt-2 pb-1 fs-7">{{ $t('request.appointment') }}:</div>
                                    <div class="fw-bold w-100">{{ list.comment }}</div>
                                </div>

                                <div class="attchmts mb-4"
                                    v-if="(list.files.length > 0) || (Object.keys(list.user_files).length > 0)">
                                    <h6>Прикрепленные файлы</h6>
                                    <div v-if="list.files.length > 0">
                                        <!-- От заявителя -->
                                        <div class="alert alert-attachments mb-2 rounded-3" role="alert">
                                            <div class="fw-semibold ps-1 mb-2 fs-7">
                                                <fa class="icon me-2 opacity-50" icon="user-tie"></fa>{{ list.user ?
                                                    list.user.surname + ' ' + list.user.name : 'Пользователь удалён' }}
                                            </div>
                                            <div v-for="file in list.files" :key="file.id">
                                                <a data-fancybox :href="file.link" class="attachment mb-1"
                                                    v-if="file.type">
                                                    <fa class="icon me-2" icon="paperclip"></fa> {{ file.name }}
                                                </a>
                                                <a @click="downloadURL(file.link, file.name)" class="attachment mb-1"
                                                    v-else>
                                                    <fa class="icon me-2" icon="paperclip"></fa> {{ file.name }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- От сотрудников -->
                                    <div v-if="Object.keys(list.user_files).length > 0">
                                        <div v-for="(items, name) in list.user_files" :key="name">
                                            <div class="alert alert-attachments mb-2 rounded-3" role="alert">
                                                <div class="fw-semibold ps-1 mb-2 fs-7">
                                                    <fa class="icon me-2 opacity-50" icon="user-tie"></fa>{{ name }}
                                                </div>
                                                <div v-for="item in items" :key="item">
                                                    <a data-fancybox :href="item.link" class="attachment mb-1"
                                                        style="cursor: pointer;" v-if="item.type">
                                                        <fa class="icon me-2" icon="paperclip"></fa> {{ item.name }}
                                                    </a>
                                                    <a @click="downloadURL(file.link, file.name)"
                                                        class="attachment mb-1" style="cursor: pointer;" v-else>
                                                        <fa class="icon me-2" icon="paperclip"></fa> {{ item.name }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div class="col-sm position-relative mb-2 mt-2" v-if="!list.first_signature">
                                <router-link class="btn btn-yellow w-100" :to="`/request/payments/edit/${list.id}`">
                                    <fa class="icon me-2 opacity-50" icon="arrows-rotate"></fa>
                                    {{ $t('request.button.revision') }}
                                </router-link>
                            </div>
                            <div v-if="!list.in_bh_work">
                                <div class="col-sm position-relative mb-2 mt-2"
                                    v-if="list.status === 'in_work' || list.status === 'revision'">
                                    <button class="btn btn-red w-100" @click="confirmDelete(list.id)">
                                        <fa class="icon me-2 opacity-50" icon="trash-can"></fa>
                                        {{ $t('request.button.delete') }}
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm position-relative mb-2 mt-2" v-if="list.status === 'denied'">
                                <button class="btn w-100 btn-green" @click="showModal(list.id)">
                                    <fa class="icon me-2 opacity-50" icon="check"></fa>
                                    {{ $t('request.button.return_to_work') }}
                                </button>
                            </div>
                            <hr />
                            <div class="col-sm position-relative mb-2 mt-2">
                                <button class="btn gray w-100" @click="getHistory(list.historys)">
                                    <fa class="icon me-2 opacity-50" icon="file-lines"></fa>
                                    {{ $t('request.button.history') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="mb-3">
                            <div class="item_title fw-semibold">
                                {{ $t('request.list_requests_is_empty') }}
                            </div>
                        </div>
                    </div>
                </template>

                <div class="pager" v-if="!is_generalnyi && pagination.total > 0">
                    <div class="pager__info">
                        Показаны {{ pagination.from || 0 }}–{{ pagination.to || 0 }} из {{ pagination.total }}
                    </div>

                    <div class="pager__controls">
                        <button class="pager__btn" :class="{ 'is-disabled': pagination.current_page <= 1 }"
                            :disabled="pagination.current_page <= 1" @click="changePage(pagination.current_page - 1)"
                            aria-label="Предыдущая" title="Предыдущая">
                            <fa icon="chevron-left" />
                        </button>

                        <div class="pager__current">
                            Стр. <b>{{ pagination.current_page }}</b> / {{ pagination.last_page }}
                        </div>

                        <button class="pager__btn"
                            :class="{ 'is-disabled': pagination.current_page >= pagination.last_page }"
                            :disabled="pagination.current_page >= pagination.last_page"
                            @click="changePage(pagination.current_page + 1)" aria-label="Следующая" title="Следующая">
                            <fa icon="chevron-right" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition-group name="list">
        <div class="modal d-block" v-if="is_modal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="btn-close close_modal" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3 mt-3">
                            <label class="col-sm-12 col-form-label required text-start">{{ $t('request.comment')
                                }}</label>
                            <div class="col-sm position-relative">
                                <textarea class="form-control" rows="3" v-model="comment"></textarea>
                            </div>
                        </div>
                        <div class="col-sm position-relative mb-2 mt-2">
                            <button class="btn btn_vw btn-red" @click="returnToWork()">
                                {{ $t('request.button.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>

    <transition-group name="list">
        <div class="modal d-block" v-if="is_delete_confirm">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Удалить заявку №{{ delete_id }}?</h5>
                        <button type="button" class="btn-close close_modal" @click="cancelDelete"></button>
                    </div>
                    <div class="modal-body">
                        <p class="mb-3">Действие нельзя отменить.</p>
                        <div class="d-flex gap-2">
                            <button class="btn btn_vw gray flex-fill" @click="cancelDelete">Отмена</button>
                            <button class="btn btn_vw btn-red flex-fill" @click="confirmedDelete">Удалить</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>

    <transition-group name="list">
        <history v-if="is_history" :historis="historis" @close-form="close" :is_print="false" :id="id" />
    </transition-group>

    <transition name="slide-fade">
        <toast-alert v-if="is_alert" @close_alert="closeAlert" :message="message" />
    </transition>
</template>

<script>
import History from "../Imprest/History";
import ToastAlert from "../../../components/ToastAlert";
import spinner from "../../../components/Spinner";
import BreadCrumbs from "../../../Page/BreadCrumbs";
import Modules from "../../../Page/Modules";
import { ErrorMessage, Field, Form } from "vee-validate";
import VueMultiselect from "vue-multiselect";
import axios from "axios";

export default {
    name: "PaymentsIndex",
    components: {
        History, ToastAlert,
        spinner, BreadCrumbs, Modules, Field, Form, ErrorMessage, VueMultiselect
    },
    data() {
        return {
            is_generalnyi: false,
            pagination: {
                current_page: 1,
                per_page: 10,
                last_page: 1,
                total: 0,
            },
            organizations: [],
            orgState: {

            },
            is_modal: false,
            is_delete_confirm: false,
            delete_id: null,
            comment: '',
            message: '',
            bg: 'bg-primary',
            is_alert: false,
            id: null,
            is_history: false,
            historis: [],
            lists: [],
            link_image: '',
            isLoading: false,
            breadCrumbs: true,
            title: this.$t('request.list_requests'),
            back_title: this.$t('request.payments'),
            link: 'request/payments',
        }
    },
    created() {
        this.getData();
    },
    methods: {
        revisionFromTo(list) {
            if (list.status !== 'revision') return '';
            try {
                const rt = typeof list.return_to === 'string' ? JSON.parse(list.return_to) : list.return_to;
                if (!Array.isArray(rt) || !rt.length) return '';
                const from = (rt[rt.length - 1]?.user?.fullname || '').split(' ')[0];
                const dp = typeof list.doc_path === 'string' ? JSON.parse(list.doc_path) : list.doc_path;
                let to = '';
                if (Array.isArray(dp) && list.executor_id) {
                    const e = dp.find(p => p?.user?.id === list.executor_id);
                    if (e) to = (e.user.fullname || '').split(' ')[0];
                }
                if (!from || !to) return '';
                return from + ' → ' + to;
            } catch (e) {
                return '';
            }
        },
        downloadURL(url, name) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    var myBlob = this.response;
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(myBlob);
                    link.download = name;
                    link.click();
                }
            };
            xhr.send();
        },
        showModal(id) {
            this.id = id;
            this.is_modal = true;
        },
        closeModal() {
            this.is_modal = false;
            this.comment = '';
        },
        returnToWork() {
            this.isLoading = true;
            const config = { 'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') } };
            axios.post('/api/admin/payments/return/work', {
                id: this.id,
                comment: this.comment,
            }, config)
                .then(response => {
                    this.isLoading = false;
                    if (response.status == 200) {
                        this.is_alert = true;
                        this.is_modal = false;
                        this.comment = '';
                        this.message = this.$t('request.application_restored');
                        setTimeout(() => { this.closeAlert(); }, 3000);
                        this.getData();
                    }
                })
                .catch(errors => {
                    this.isLoading = false;
                    console.log(errors);
                });
        },
        cur(val) {
            if (!val) {
                return "0";
            }

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        closeAlert() {
            this.is_alert = false;
        },
        close() {
            this.is_history = false;
        },
        getHistory(data, id) {
            this.historis = data;
            this.id = id;
            this.is_history = true;
        },
        confirmDelete(id) {
            this.delete_id = id;
            this.is_delete_confirm = true;
        },
        cancelDelete() {
            this.is_delete_confirm = false;
            this.delete_id = null;
        },
        confirmedDelete() {
            const id = this.delete_id;
            this.is_delete_confirm = false;
            this.delete_id = null;
            if (id != null) this.deletePayment(id);
        },
        deletePayment(id) {
            this.isLoading = true;
            const config = { 'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') } };
            axios.post('/api/admin/payments/delete', {
                id: id,
            }, config)
                .then(response => {
                    this.isLoading = false;
                    if (response.status == 200) {
                        this.is_alert = true;
                        this.message = this.$t('request.request_delete');
                        setTimeout(() => { this.closeAlert(); }, 3000);
                        this.getData();
                    }
                })
                .catch(errors => {
                    this.isLoading = false;
                    console.log(errors);
                });
        },
        async getData(page = 1) {
            try {
                this.isLoading = true;
                const cfg = { headers: { Authorization: 'Bearer ' + this.$cookie.getCookie('token') } };

                const resp = await axios.get('/api/admin/payments/index', {
                    ...cfg,
                    params: { page, per_page: this.pagination.per_page }
                });
                this.is_generalnyi = !!resp.data.data.is_generalnyi;

                if (this.is_generalnyi) {
                    const r2 = await axios.get('/api/admin/payments/orgs', cfg);
                    this.organizations = r2.data.data.organizations || [];

                    this.organizations.forEach(o => {
                        if (!(o.id in this.orgState)) {
                            this.orgState = {
                                ...this.orgState,
                                [o.id]: {
                                    opened: false,
                                    loading: false,
                                    items: [],
                                    pagination: {
                                        current_page: 1,
                                        per_page: 10,
                                        last_page: 1,
                                        total: o.total,
                                        from: 0,
                                        to: 0
                                    },
                                }
                            };
                        } else {
                            this.orgState[o.id].pagination.total = o.total;
                        }
                    });
                } else {
                    const p = resp.data.data.pagination || {};
                    this.lists = resp.data.data.lists || [];
                    this.pagination = { ...this.pagination, ...p };
                }
            } finally {
                this.isLoading = false;
            }
        },

        async changePage(toPage) {
            if (toPage < 1 || toPage > this.pagination.last_page) return;
            await this.getData(toPage);
        },

        async loadOrgPage(orgId, page = 1) {
            const st = this.orgState[orgId];
            if (!st) return;
            try {
                st.loading = true;
                const cfg = {
                    headers: { Authorization: 'Bearer ' + this.$cookie.getCookie('token') },
                    params: { page, per_page: st.pagination.per_page }
                };
                const resp = await axios.get(`/api/admin/payments/org/${orgId}`, cfg);
                st.items = resp.data.data.requests || [];
                st.pagination = { ...st.pagination, ...(resp.data.data.pagination || {}) };
            } finally {
                st.loading = false;
            }
        },

        async toggleOrg(orgId) {
            const st = this.orgState[orgId];
            if (!st) return;
            st.opened = !st.opened;
            if (st.opened && st.items.length === 0) {
                await this.loadOrgPage(orgId, 1);
            }
        },

        async changeOrgPage(orgId, toPage) {
            const st = this.orgState[orgId];
            if (!st) return;
            if (toPage < 1 || toPage > st.pagination.last_page) return;
            await this.loadOrgPage(orgId, toPage);
        },
    }
}
</script>

<style scoped>
.pager {
    margin-top: 1rem;
    padding: 0.75rem 1rem;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
}

.pager--inner {
    margin-top: 1rem;
}

.pager__info {
    font-size: 14px;
    color: #6b7280;
}

.pager__controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pager__current {
    font-size: 14px;
    color: #111827;
    min-width: 120px;
    text-align: center;
}

.pager__btn {
    height: 38px;
    width: 42px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    color: #111827;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all .15s ease;
}

.pager__btn:hover {
    background: #ffffff;
    border-color: #d1d5db;
    box-shadow: 0 2px 6px rgba(16, 24, 40, 0.08);
}

.pager__btn:active {
    transform: translateY(1px);
}

.pager__btn.is-disabled,
.pager__btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    background: #f3f4f6;
    border-color: #e5e7eb;
    box-shadow: none;
}
</style>
